import { CompaniesRoot, ScreenRoot } from "types";

export const CompaniesRootDefinition: ScreenRoot = {
  name: CompaniesRoot,
  routePath: ["/companies/*"],
  accessPath: "company",
};
